import { PudoTransactionTimerActivityWeekdayHeatmapChart, hasChartSeries } from '@frontend/chart/components';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import { useInsightHeatmapCellClick } from '../heatmap-cell-summary/use-insight-heatmap-cell-click';
import { InsightCardWidth } from '../insight-card-width';
import { InsightCard } from '../insight-card/insight-card.component';
import { useInsightChartMinHeight } from '../insight-detail-mode.context';
import { InsightId } from '../insight-registry/insight-ids';
import { useLast6MonthsPudoTransactionTimerActivityWeekdayHeatmapChart } from './use-last-6-months-pudo-transaction-timer-activity-weekday-heatmap-chart';

export interface Last6MonthsPudoTransactionTimerActivityWeekdayHeatmapChartProps {
    accountId: string;
    width?: InsightCardWidth;
}

export const Last6MonthsPudoTransactionTimerActivityWeekdayHeatmapChart = ({
    accountId,
    width
}: Last6MonthsPudoTransactionTimerActivityWeekdayHeatmapChartProps) => {
    const chartMinHeight = useInsightChartMinHeight(220);
    const { data, isLoading, rangeStart, weekCount } = useLast6MonthsPudoTransactionTimerActivityWeekdayHeatmapChart(accountId);
    const title = (
        <FormattedMessage
            id='platform.analytics.insights.last-6-months-pudo-transaction-timer-activity-weekday-heatmap-chart.title'
            description='Title of the PuDo insights heatmap showing combined completed drop-off and pick-up timer volume by weekday over the last six months'
            defaultMessage='Activity heatmap'
        />
    );
    const onCellClick = useInsightHeatmapCellClick({
        accountId,
        chartKey: PudoTransactionTimerActivityWeekdayHeatmapChart.definition.key,
        title
    });

    return (
        <InsightCard
            insightId={InsightId.PUDO_ACTIVITY_WEEKDAY_HEATMAP}
            chartKey={PudoTransactionTimerActivityWeekdayHeatmapChart.definition.key}
            width={width}
            title={title}
            subtitle={
                <FormattedMessage
                    id='platform.analytics.insights.last-6-months-pudo-transaction-timer-activity-weekday-heatmap-chart.subtitle'
                    description='Subtitle on the PuDo activity heatmap indicating the chart covers the last six months'
                    defaultMessage='last 6 months'
                />
            }
            isLoading={isLoading}>
            {!hasChartSeries(data) || !data ? (
                <div className='text-foreground-default'>{CommonMessage.ERRORS.NO_DATA_AVAILABLE}</div>
            ) : (
                <div
                    className='w-full min-w-0 overflow-hidden'
                    style={{ height: chartMinHeight }}>
                    <PudoTransactionTimerActivityWeekdayHeatmapChart
                        data={data}
                        rangeStart={rangeStart}
                        weekCount={weekCount}
                        minHeight={chartMinHeight}
                        onCellClick={onCellClick}
                    />
                </div>
            )}
        </InsightCard>
    );
};
